import React, { useEffect, useState } from 'react';

import Cookies from 'js-cookie';

import { COOKIE_AGREE, COOKIE_CONSENT } from '@/helpers/cookieHelpers';

import './CookieBanner.scss';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isGTMGranted, setIsGTMGranted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      pushCookieConsentToGTM();
      window.removeEventListener('scroll', handleScroll);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isGTMGranted]);

  const pushCookieConsentToGTM = () => {
    const { gtag } = window;

    if (gtag && !isGTMGranted) {
      gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
      setIsGTMGranted(true);
    }
  };

  useEffect(() => {
    const cookieConsent = Cookies.get(COOKIE_AGREE);

    if (!cookieConsent) {
      setShowBanner(true);
    } else {
      pushCookieConsentToGTM();
    }
  }, []);

  const handleAgree = () => {
    Cookies.set(COOKIE_AGREE, 'true', { expires: 365 });
    Cookies.set(COOKIE_CONSENT, 'true', { expires: 365 });
    pushCookieConsentToGTM();

    const event = new CustomEvent('cookie-all-accepted-at-once');

    window.dispatchEvent(event);

    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-container">
      <span className="body-2">
        We use cookies on our website to improve its functionality and to enhance your user experience. We also use
        cookies for analytics. If you continue to browse this website, we will assume you agree that we can place
        cookies on your device. If you would like to, you can change your cookie options at any time. For more details,
        please read our{' '}
        <a href="/privacy-and-cookies-policy" className="text-link">
          Privacy and Cookies Policy
        </a>
        .
      </span>
      <button type="button" className="button-func button-2 button-yellow" onClick={handleAgree}>
        I agree
      </button>
    </div>
  );
};

export default CookieBanner;
